/**
 * Manages the state for the one panel survey
 */
import { useReducer, useEffect } from "react";
import {
  ADVANCE_ONE_PANEL_SURVEY,
  INIT,
  ON_CHANGE,
  RESET,
  REVERT_ONE_PANEL_SURVEY,
  SET_RENDER,
  SHOW_AUTOPOP_UP,
  SHOW_ONE_PANEL_SURVEY_COMPLETION,
  ONE_PANEL_SURVEY_CONTENT,
  TOGGLE_IDLE,
  TOGGLE_ONE_PANEL_SURVEY,
} from "../../constants";

const FREETEXT_MAX_LENGTH = 600;

const initialState = {
  isOpen: false,
  questions: [],
  questionIndex: 0,
  selectedAnswer: null,
  isValid: false,
  render: false,
  isEndOfOnePanelSurvey: false,
  showOnePanelSurveyCompletion: false,
  onePanelSurveyCompletion: {},
  onePanelSurveyAutoPopUp: false,
  isIdle: false,
  isIdleTimeoutEnabled: false,
};

const onePanelSurveyReducer = (state, action) => {
  const validate = () => {
    let isValid = false;
    const { isFreeText, isOptional } =
      state.questions[action.payload.questionIndex || state.questionIndex] ||
      {};

    if (isOptional) {
      isValid = isFreeText
        ? !(
            action.payload.selectedAnswer &&
            action.payload.selectedAnswer.length > FREETEXT_MAX_LENGTH
          )
        : true;
    } else if (isFreeText) {
      isValid =
        action.payload.selectedAnswer &&
        action.payload.selectedAnswer.length <= FREETEXT_MAX_LENGTH;
    } else {
      isValid = !!action.payload.selectedAnswer;
    }

    return isValid;
  };

  switch (action.type) {
    case INIT:
    case SHOW_AUTOPOP_UP: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case SET_RENDER: {
      return {
        ...state,
        render: action.payload,
      };
    }

    case TOGGLE_ONE_PANEL_SURVEY: {
      return {
        ...state,
        isOpen: action.payload,
      };
    }

    case RESET: {
      return {
        ...state,
        isOpen: initialState.isOpen,
        questionIndex: initialState.questionIndex,
        selectedAnswer: initialState.selectedAnswer,
        isEndOfOnePanelSurvey: initialState.isEndOfOnePanelSurvey,
        showOnePanelSurveyCompletion: initialState.showOnePanelSurveyCompletion,
        isValid: initialState.isValid,
        isIdle: initialState.isIdle,
      };
    }

    case ADVANCE_ONE_PANEL_SURVEY: {
      let isEndOfOnePanelSurvey = false;

      return {
        ...state,
        questionIndex: action.payload.questionIndex,
        selectedAnswer: action.payload.selectedAnswer,
        isEndOfOnePanelSurvey,
        isValid: validate(),
      };
    }

    case REVERT_ONE_PANEL_SURVEY: {
      return {
        ...state,
        questionIndex: action.payload.questionIndex,
        selectedAnswer: action.payload.selectedAnswer,
        isEndOfOnePanelSurvey: action.payload.isEndOfOnePanelSurvey,
        isValid: validate(),
      };
    }

    case ON_CHANGE: {
      return {
        ...state,
        selectedAnswer: action.payload.selectedAnswer,
        isEndOfOnePanelSurvey: action.payload.isEndOfOnePanelSurvey,
        isValid: validate(),
      };
    }

    case SHOW_ONE_PANEL_SURVEY_COMPLETION: {
      return {
        ...state,
        showOnePanelSurveyCompletion: true,
      };
    }

    case TOGGLE_IDLE: {
      return {
        ...state,
        isIdle: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

const useOnePanelSurveyStateManager = (props) => {
  const [state, dispatch] = useReducer(onePanelSurveyReducer, initialState);

  useEffect(() => {
    if (!props.definition) return;

    const { definition } = props;

    const { onePanelSurveyQuestions } = definition[ONE_PANEL_SURVEY_CONTENT];

    initialState.questions = onePanelSurveyQuestions;
  }, []);

  return [state, dispatch];
};

export default useOnePanelSurveyStateManager;
